import React from 'react'

// Removed Alert, Modal imports
// Added CBAlert, CBModal imports
import { CBAlert, CBModal } from '../../../core/components/cbd';


const DeleteAccountModal = ({
	visible,
	handleOk,
	confirmLoading,
	handleCancel,
}) => {
	return (
		// Replaced Modal with CBModal
		<CBModal
			title="Delete Account"
			visible={visible}
			onPositiveClick={handleOk} // Map onOk
			confirmLoading={confirmLoading} // Assuming CBModal supports this
			onCancelClick={handleCancel} // Map onCancel
			positiveLabel="Delete" // Make positive button text explicit
			positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }} // Add danger styling
		>
			{/* Replaced Alert with CBAlert */}
			<CBAlert
				title="ALERT" // Use title prop if available, otherwise combine into message/description
				message="This will permanently remove this account and all of its data."
				variant="error" // Map type
				// showIcon - CBAlert might show icon by default based on variant
			/>
		</CBModal>
	)
}

export default DeleteAccountModal
